import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';

export async function createZoneAPI(zone) {
  const url = `${AWS_API_URL}/2n/zones`;
  return postRequest(url, { data: zone }, await authorize());
}

